import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

export default function Create_hubbucket() {
  const title = "Add Hub-Bucket";
  const [formData, setFormData] = useState({
    bucket: "",
    id_hub: "",
  });
  const [autocomplete, setAutocomplete] = useState(null);
  const [errors, setErrors] = useState({});
  const [hubs, setHubs] = useState([]);

  const navigate = useNavigate();

  const brad = [{ name: "Home" }, { name: title }];

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.bucket) newErrors.bucket = "Bucket Name is required";
    if (!formData.id_hub) newErrors.id_hub = "Hub Name is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    data.append("bucket", formData.bucket);
    data.append("id_hub", formData.id_hub);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v2/hub-bucket/new`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/hubbucket");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setHubs(response.data.hubs);
      } catch (error) {
        console.error("Error fetching hub:", error);
        setHubs([]);
      }
    };
    fetchHubs();
  }, []);

  const hubOptions = hubs.map((hub) => ({
    value: hub._id,
    label: hub.name,
  }));

  const handleHubChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_hub: selectedOption ? selectedOption.value : "",
    }));
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="bucket">
                  <b>Bucket *</b>
                </label>
                <select
                  name="bucket"
                  className="form-control"
                  value={formData.bucket}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Trips</option>

                  <option value="trips">Trips</option>
                  <option value="ride">Ride</option>
                  <option value="order">Order</option>
                </select>
                {errors.bucket && (
                  <p className="text-danger">{errors.bucket}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="hub">
                  <b>Hub *</b>
                </label>
                <Select
                  name="id_hub"
                  options={hubOptions}
                  onChange={handleHubChange}
                  value={hubOptions.find(
                    (option) => option.value === formData.id_hub
                  )}
                  isClearable
                  placeholder="Select Hub"
                  className="basic-single"
                  classNamePrefix="select"
                />
                {errors.id_hub && (
                  <p className="text-danger">{errors.id_hub}</p>
                )}
              </div>

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Hub
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
